import { CreateAPIKeyRequest, TcnService, IntegrationsService } from '@/api';
import { action, atom } from 'nanostores';

export const $tcnApiKey = atom<string | undefined>(undefined);

/**
 * Main function to load apiKey
 */
const loadTcnIntegration = async (orgId: string) => {
  if (orgId) {
    console.log('Retrieving TCN OrgIntegration...');

    await ensureOrganization(orgId);

    var Integrations = await IntegrationsService.getProfileIntegrations(orgId);

    // filter the integrations to get the TCN integration
    const tcnIntegration = Integrations.find(i => i.integration?.type === 'TCN');

    $tcnApiKey.set(tcnIntegration?.apiKey ?? undefined);

    // set the workspace ids in local storage since we are gonna use it later
    // for drag and drop, these workspace ids will act as order of the workspaces
    const existingApiKey = JSON.parse(
      localStorage.getItem('tcn_api_key') ?? '{}',
    );
    existingApiKey[orgId] = tcnIntegration;
    localStorage.setItem(
      'tcn_api_key',
      JSON.stringify(existingApiKey),
    );
  }
};

/**
 * Reload apiKey on org change
 */
$org.subscribe(async org => {
  $tcnApiKey.set(undefined);

  await loadTcnIntegration(org?.id ?? '');
});


export const createTcnApiKey = action(
  $tcnApiKey,
  'createTcnApiKey',
  async (store, apiKey: string, organizationId: string) => {
    const request: CreateAPIKeyRequest = {
      orgId: organizationId,
      apiKey,
    };
    
    const res = await TcnService.createApiKey(request);

    // Check for any kind of failure
    if (!res.success) {
      return { error: 'An error occurred while saving the TCN API key' };
    }

    // Use this to update the store
    $tcnApiKey.set(apiKey);
  },
);

export const revokeTcnApiKey = action(
  $tcnApiKey,
  'revokeTcnApiKey',
  async (store, organizationId: string) => {
    const res = await TcnService.revokeApiKey(organizationId);

    console.log('inside revokeTcnApiKey');
    console.log(res);

    if (!res.success) {
      return { error: 'An error occurred while revoking the TCN API key' };
    }
    $tcnApiKey.set(undefined);
  },
);
